/**
 * 组装 `yaml-configs/save` 单条 items[0]`，与 Step4 `handleSaveDraft` 入参一致。
 * 新建不传 uuid；已存在 `savedUuid` 时带上以走更新。
 */
import type { IYamlConfigSaveItem } from '../../ModelManagementCenter/types';
import type {
  IStepFieldConfigState,
  IStepSelectTablesState,
} from '../types';

export function buildSaveYamlItem(input: {
  gameCode: string;
  yamlText: string;
  cubeName: string;
  selectTables: IStepSelectTablesState;
  fieldConfig: IStepFieldConfigState;
  savedUuid: string;
}): IYamlConfigSaveItem {
  const { gameCode, yamlText, cubeName, selectTables, savedUuid, fieldConfig } = input || {};
  const firstId = selectTables.tablesValue[0] || '';
  const tableName = selectTables.tablesName || firstId;
  const dbItem = selectTables.dataBaseData?.find(
    (d) => d.database_uuid === selectTables.databaseValue,
  );
  const databaseName = dbItem?.database_name || '';

  const cubeConfig = {
    fieldConfig
  };
  const item: IYamlConfigSaveItem = {
    game_code: gameCode,
    name: cubeName || tableName,
    yaml_context: yamlText,
    database_uuid: selectTables.databaseValue,
    database_name: databaseName,
    table_id: firstId,
    table_name: tableName,
    cube_config_json: JSON.stringify(cubeConfig),
  };
  if (savedUuid) {
    item.uuid = savedUuid;
  }
  return item;
}
